export const genericTextRegex = /^[a-z\d\-:(),'"\s]+$/i

export const phoneRegex = /^\+?[0-9]{3}-?[0-9]{6,12}$/